var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridIcon40250Pm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FF9316"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3160_2766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4853 11.5957C26.2188 9.32929 23.2053 8.08105 20 8.08105C16.7947 8.08105 13.7812 9.32929 11.5147 11.5957C9.2525 13.858 8.00473 16.9294 8 20.1279C8 22.9033 8.96867 25.5916 10.7294 27.7309C12.4661 29.8409 14.888 31.307 17.5492 31.8592C17.739 31.8987 17.9324 31.9186 18.1263 31.9186C18.7672 31.9186 19.3918 31.6997 19.8999 31.2863C20.5588 30.7503 20.9367 29.9556 20.9369 29.1062L20.9375 25.0517C23.0211 24.6271 24.5938 22.7804 24.5938 20.5732V18.1592C24.5938 17.6414 24.1741 17.2217 23.6563 17.2217H22.8595V14.8311C22.8595 14.3133 22.4398 13.8936 21.922 13.8936C21.4042 13.8936 20.9845 14.3133 20.9845 14.8311V17.2217H19.1095V14.8311C19.1095 14.3133 18.6897 13.8936 18.172 13.8936C17.6542 13.8936 17.2345 14.3133 17.2345 14.8311V17.2217H16.3907C15.8729 17.2217 15.4532 17.6414 15.4532 18.1592V20.5732C15.4532 22.7637 17.0023 24.5989 19.0625 25.0416L19.0619 29.1059C19.0618 29.4932 18.8455 29.727 18.7165 29.8319C18.608 29.9205 18.4811 29.9836 18.3451 30.0167C18.209 30.0498 18.0673 30.0521 17.9302 30.0233C13.2679 29.0558 9.88231 24.8963 9.87402 20.1279C9.87402 20.1279 9.87505 20.1397 9.87505 20.1279C9.87505 14.545 14.4171 9.95605 20 9.95605C25.583 9.95605 30.125 14.4981 30.125 20.0811C30.125 24.174 27.6999 27.8463 23.9468 29.4366C23.4701 29.6386 23.2473 30.1888 23.4493 30.6656C23.6514 31.1423 24.2016 31.3651 24.6783 31.163C26.8205 30.2554 28.6445 28.7469 29.9532 26.8006C31.2922 24.8092 32 22.4856 32 20.0811C32 16.8757 30.7518 13.8622 28.4853 11.5957ZM17.3281 20.5732V19.0967H22.7188V20.5732C22.7188 22.0595 21.5097 23.2686 20.0234 23.2686C18.5372 23.2686 17.3281 22.0594 17.3281 20.5732Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3160_2766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon40250Pm);
export default __webpack_public_path__ + "static/media/GridIcon 4.02.50 PM.14ffe0644514c7b33f147dcaff3d335d.svg";
export { ForwardRef as ReactComponent };